import { Container, Text } from 'pixi.js';

export class UI extends Container {
  private scoreText!: Text;
  private debugText?: Text;
  private gameWidth: number;
  private padding: number = 20;
  private onScoreClickCallback?: () => void;

  constructor(gameWidth: number, _gameHeight: number) {
    super();

    this.gameWidth = gameWidth;

    this.createScoreText();
    this.createDebugText();
  }

  private createScoreText(): void {
    this.scoreText = new Text({
      text: '0 🐾',
      style: {
        fontFamily: 'Rubik',
        fontSize: 24,
        fontWeight: 'bold',
        fill: 0xffd700,
        stroke: { color: 0x000000, width: 3 },
      },
    });

    this.scoreText.anchor.set(1, 0);
    this.scoreText.x = this.gameWidth - this.padding;
    this.scoreText.y = this.padding;

    this.scoreText.eventMode = 'static';
    this.scoreText.cursor = 'pointer';

    this.scoreText.on('pointerdown', () => {
      if (this.onScoreClickCallback) {
        this.onScoreClickCallback();
      }
    });

    this.addChild(this.scoreText);
  }

  private createDebugText(): void {
    this.debugText = new Text({
      text: '',
      style: {
        fontFamily: 'monospace',
        fontSize: 14,
        fontWeight: 'normal',
        fill: 0x00ff00,
        stroke: { color: 0x000000, width: 2 },
      },
    });

    this.debugText.anchor.set(0.5, 0);
    this.debugText.x = this.gameWidth / 2;
    this.debugText.y = this.padding;
    this.debugText.visible = false;

    this.addChild(this.debugText);
  }

  updateScore(score: number): void {
    this.scoreText.text = `${score} 🐾`;
  }

  updateDimensions(gameWidth: number, _gameHeight: number): void {
    this.gameWidth = gameWidth;

    this.scoreText.x = this.gameWidth - this.padding;
    this.scoreText.y = this.padding;

    if (this.debugText) {
      this.debugText.x = this.gameWidth / 2;
      this.debugText.y = this.padding;
    }
  }

  onScoreClick(callback: () => void): void {
    this.onScoreClickCallback = callback;
  }

  updateDebugInfo(speed: number, spawnInterval: number, isDebugMode: boolean): void {
    if (this.debugText) {
      this.debugText.visible = isDebugMode;
      if (isDebugMode) {
        this.debugText.text = `Speed: ${Math.round(speed)} | Spawn: ${spawnInterval.toFixed(2)}s`;
      }
    }
  }
}
